<template>
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="11.5"
      cy="11.5"
      r="11.5"
      fill="url(#paint0_linear_4309_10719)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.6827 7.28001C19.1058 7.65335 19.1058 8.25865 18.6827 8.632L10.3333 16L6.3173 12.456C5.89423 12.0827 5.89423 11.4774 6.3173 11.104C6.74037 10.7307 7.4263 10.7307 7.84937 11.104L10.3333 13.296L17.1506 7.28001C17.5737 6.90666 18.2596 6.90666 18.6827 7.28001Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4309_10719"
        x1="9.87955"
        y1="-6.48182"
        x2="29.7555"
        y2="-1.51283"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00C572" />
        <stop offset="1" stop-color="#63ECCB" />
      </linearGradient>
    </defs>
  </svg>
</template>
